import "src/newrelic";

import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "src/App";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(<App />);

//@ts-ignore
if (module.hot) module.hot.accept();
